import { render, staticRenderFns } from "./CardData.vue?vue&type=template&id=5a0127ea&scoped=true"
import script from "./CardData.vue?vue&type=script&lang=js"
export * from "./CardData.vue?vue&type=script&lang=js"
import style0 from "./CardData.vue?vue&type=style&index=0&id=5a0127ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0127ea",
  null
  
)

export default component.exports